import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    @media (min-width: 992px) {
        padding-left: 0 107px;
    }
`;

const HeaderContainer = styled(Container)`
    position: fixed;
    background-color: #000000;
    height: 64px;
    width: 100%;
    color: #ffffff;
`;

const Logo = styled.img`
    height: 40px;
    margin-top: auto;
    margin-bottom: auto;
    vertical-align: middle;
`;
const Title = styled.h1`
    font-family: ${({ theme }) => theme.font.family.heading};
    font-size: ${({ theme }) => theme.font.size.lg};
    font-weight: ${({ theme }) => theme.font.weight.semibold};
    text-align: left;
    letter-spacing: -0.25px;
    margin: auto 0px auto 1rem;
    display: inline;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media (max-width: 576px) {
        font-size: ${({ theme }) => theme.font.size.mobile.lg};
    }
`;

const FlexEndContainer = styled.div`
    align-items: center;
    display: inline-flex;
`;

const FlexStartContainer = styled.div`
    align-items: center;
    display: inline-flex;
    padding-left: 1rem;
    flex: 1;
`;
export { HeaderContainer, Logo, Title, FlexEndContainer, FlexStartContainer };
